import React from 'react';

import BrandLink from '../brands/BrandLink';
import { BrandLinks } from '../brands/Link';
import ListSelect from '../generic/ListSelect';
import { FILTER_TYPES } from '../generic/Table/utils';
import MerchantLink from '../merchants/MerchantLink';
import QuoteLink from '../quotes/QuoteLink';
import UserLink from '../users/UserLink';
import {
  dateColumn,
  filterMultiBy,
  filterSingleBy,
  simpleColumn,
} from './column-helpers';

export const name     = simpleColumn('Name',      'name'    ); // prettier-ignore
export const email    = simpleColumn('Email',     'email'   ); // prettier-ignore
export const lastName = simpleColumn('Last Name', 'lastName'); // prettier-ignore

export const created = dateColumn('Created', 'created');
export const createdBy = simpleColumn('Created By', 'createdBy');

export const modified = dateColumn('Last Modified', 'lastModified');
export const modifiedBy = simpleColumn('Last Modified By', 'lastModifiedBy');

export const brandLink = (accessor = 'brand', width, verbose = true) => ({
  Header: 'Brand',
  accessor,
  width,
  Cell: row => {
    const model = row.value;
    if (model.id) {
      return <BrandLink model={model} verbose={verbose} />;
    }
    return (
      <div>
        {model.name} <span className="small">{model.code}</span>
      </div>
    );
  },
});

export const brandLinks = {
  Header: 'Brands',
  accessor: 'brands',
  filterMethod: (filter, value) => filterMultiBy(filter, value.brands, 'id'),
  Cell: row => <BrandLinks models={row.value} />,
  Filter: props => <ListSelect {...props} type="brand" />,
  filterCriteria: FILTER_TYPES.LIST_SELECT,
  sortable: false,
  filterKey: 'brandIds',
};

export const selfServiceMerchantLink = {
  Header: 'Self Service Merchant',
  accessor: 'selfServiceMerchant',
  width: 150,
  Cell: row => (row.value ? <MerchantLink model={row.value} /> : null),
  Filter: props => <ListSelect {...props} type="allZmsamMerchant" />,
  filterCriteria: FILTER_TYPES.LIST_SELECT,
  filterKey: 'selfServiceMerchantId',
  sortable: false,
};

export const ownerLink = {
  Header: 'Owner',
  id: 'owner',
  accessor: 'owner',
  width: 200,
  filterMethod: (filter, value) =>
    value.owner && filterSingleBy(filter, value.owner.id),
  Cell: row => row.value && <UserLink model={row.value} />,
  Filter: props => <ListSelect {...props} type="user" />,
  filterCriteria: FILTER_TYPES.LIST_SELECT,
  filterKey: 'ownerId',
  sortKey: 'owner__firstName',
};

export const quoteLink = {
  Header: 'Quote',
  accessor: 'quote',
  width: 200,
  filterMethod: (filter, value) =>
    value.quote && filterSingleBy(filter, value.quote.id),
  Cell: row => row.value && <QuoteLink model={row.value} />,
  Filter: props => <ListSelect {...props} type="quote" />,
  filterCriteria: FILTER_TYPES.LIST_SELECT,
  filterKey: 'quoteId',
  sortKey: 'quote__name',
};

export const salesUnitColumn = (accessor, filterKey = '', id = '') => ({
  Header: 'Sales Unit',
  accessor,
  id: id || accessor,
  width: 100,
  filterMethod: (filter, value) => filterSingleBy(filter, value.salesUnit),
  filterKey: filterKey || accessor,
});

export const salesTeamColumn = (accessor, filterKey = '', id = '') => ({
  Header: 'Sales Team',
  accessor,
  id: id || accessor,
  width: 100,
  filterMethod: (filter, value) => filterSingleBy(filter, value.salesTeam),
  filterKey: filterKey || accessor,
});
